/* eslint-disable no-tabs */
/* eslint-disable indent */
/* eslint-disable semi */
/* eslint-disable space-before-function-paren */

export function getQueryString() {
	return [{}, ...window.location.search.substr(1).split('&').map(x => {
		const kv = x.split('=');
		return { [kv[0]]: kv[1] };
	})].reduce((acc, curr) => {
		return { ...acc, ...curr };
	});
}

export function platform(): 'ios' | 'web' | 'android' {
	const qs = getQueryString();
	if (qs && 'platform' in qs) {
		const platform = qs.platform?.toString().toLowerCase();
		if (platform && ['android', 'ios'].indexOf(platform) > -1) {
			return platform as any;
		}
	}
	return 'web';
}

export function isTestMode() {
	return ['localhost', '10.1.1.', '192.168.1.'].filter(x => window.location.hostname.indexOf(x) > -1).length > 0;
}
